module.exports = __webpack_public_path__ + "./images/8eb55d30dc0cbb998a130d5afa05fd15.webp";